import { UserSchema } from "mock/schemas"
import { createContext, useCallback, useEffect, useState } from "react"
import { AuthContextInterface, AuthProviderType } from "types/auth"

export const MockAuthContext = createContext({} as AuthContextInterface)

export const MockProviderComponent: AuthProviderType = ({ children }) => {
    const [user, setUser] = useState<null | UserSchema>(null)
    const [isAuthenticated, setIsAuthenticated] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const logout = useCallback(async () => {
        setUser(null)
    }, [])

    const getAccessTokenSilently = useCallback(async () => {
        return user ? user.id : undefined
    }, [user])

    useEffect(() => {
        setIsAuthenticated(user !== null)
    }, [user])

    const auth = {
        isAuthenticated,
        isLoading,
        logout,
        getAccessTokenSilently,
        user,
        setUser,
        setIsLoading,
    }

    return (
        <MockAuthContext.Provider value={auth}>
            {children}
        </MockAuthContext.Provider>
    )
}
